// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"100":"e48599ff","239":"7c76ca81","455":"fe978462","644":"dd4dabf6","963":"adba031e"}[chunkId] + ".chunk.js";
};